import React from 'react';

import ErrorBoundary from './components/ErrorBoundary';

const withErrorBoundary = (Component: React.FunctionComponent) => (props: { [k in string]: unknown }): JSX.Element => (
  <ErrorBoundary>
    <Component {...props} />
  </ErrorBoundary>
);

export default withErrorBoundary;
